import './JtsFormMessage.scss';

import React       from 'react';
import classNames  from 'classnames';
import { IconSvg } from './IconSvg';
import alertSvg    from '../../../../icons/alert.svg';

export enum MessageType {
	Info = 0,
	Warning,
	Error,
}

export interface IJtsFormMessageProps {
	type: MessageType;
	message: string[];
}

export class JtsFormMessage extends React.Component<IJtsFormMessageProps> {

	public render() {
		const {message, type} = this.props;
		const total = message.length;

		return <div className={classNames(
			'jts-form-message',
			{info: type === MessageType.Info},
			{warning: type === MessageType.Warning},
			{error: type === MessageType.Error}
		)}>
			<div className="jts-form-message-icon">
				<IconSvg size={20} svg={alertSvg}/>
			</div>

			<div>
				{message.map((msg, key) => <div key={key}>{total > 1 ? '- ' : null}{msg}</div>)}
			</div>
		</div>;
	}
}
